import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  useSettings,
  Language,
} from '@/museum-app/context/settings-context';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface LanguageOption {
  value: Language;
  label: string; // Native language name
}

const languageOptions: LanguageOption[] = [
  { value: 'en', label: 'English' },
  { value: 'pt', label: 'Português' },
  { value: 'fr', label: 'Français' },
];

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useSettings();
  const { t } = useTranslation();

  const handleValueChange = (value: string) => {
    // Type assertion needed as Radix Select returns string
    setLanguage(value as Language);
  };

  return (
    <Select value={language} onValueChange={handleValueChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue
          placeholder={t('settings.language.selectPlaceholder', 'Select language')}
        />
      </SelectTrigger>
      <SelectContent>
        {languageOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
